import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  OverviewCard,
  PageTitleAndSubTitle,
  Breadcrumbs,
  CardComponent,
  BasicTable,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CostValues,
  MemberValues,
  PEPM,
  PMPM,
  TotalCost,
} from '../../core-utils/helper-utils/summaryReportHelper';
import {
  COMMON_TEXTS,
  scrollBarStyles,
} from '../../core-utils/messages/CommonConstants';
import {
  DEEP_DIVE,
  PATIENT_DETAILS,
  RX_UTILIZATION,
} from '../../core-utils/routes';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import TabSelection from '../../_components/molecules/TabSelection';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { pageScrollDown } from '../SummaryPage';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
// import DrugCategoriesChart from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/DrugCategoriesChart';
import utilizationRx from '../../core-utils/messages/utilizationRx';
import SPECIALITY_DRUGS_MESSAGES from './textConstants';
import {
  // IDrugCategories,
  ILabel,
  IValue,
  // formatDrugCategoriesResponse,
} from '../../core-utils/helper-utils/pharmacySpendHelper';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  commasForNumbers,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import componentConstants from '../../core-utils/messages/componentConstants';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { Pagination } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import { collapsiblePatientTableHeaderStyles } from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import {
  formatTopDrugsData,
  topDrugsTableColumn,
} from '../UtilizationRx/utilizationRxConstants';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import moment from 'moment';
import {
  formatMembersListData,
  specialityDrugColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import useTotalEligible from '../../core-utils/custom-hooks/TotalEligible';
import DateFilter from '../../_components/molecules/DateFilter';
import { observer } from 'mobx-react';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import { getCohortMemberCountForOtherDrugs } from '../../core-utils/axios/Cohort/MedPharma';

interface IRxDrugSurgeChartData {
  labels: ILabel[];
  brandedCurrentYearValues: IValue[];
  brandedPreviousYearValues: IValue[];
  genericCurrentYearValues: IValue[];
  genericPreviousYearValues: IValue[];
}

const SpecialityDrugsPage = observer(() => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
    },
  });

  const { classes } = useStyles();

  const employerGroupStore = useStores().employerGroupStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const memberSummaryStore = useStores().memberSummaryStore;
  const recommendedTabStore = useStores().recommendedTabStore;
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;
  const loginPageStore = useStores().loginPageStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  //Text Constants :
  const messages = SPECIALITY_DRUGS_MESSAGES;
  const pageConstants = componentConstants.PAGES.PHARMACY_SPEND_PAGES;
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  //OverView Cards Use States:

  const [memberValues, setMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });

  const [costValues, setCostValues] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });

  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });

  const [pmpm] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });

  const [pepm] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });

  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState(0);

  const [pageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [clickedMember, setClickedMember] = useState<string>('');
  const [memberIds, setMemberIds] = useState<any>([]);
  const [riskMemberListData, setRiskMemberListData] = useState<any[]>([]);
  const [drugsData, setDrugsData] = useState<any[]>([]);

  const [isTopDrugsTableLoading, setIsTopDrugsTableLoading] = useState<boolean>(
    false,
  );
  const [
    topDrugsTableCurrentPage,
    setTopDrugsTableCurrentPage,
  ] = useState<number>(1);
  const [
    topDrugsTableTotalPages,
    setTopDrugsTableTotalPages,
  ] = useState<number>(20);

  const [sortField, setSortField] = useState(pageConstants.MAIN_SORT_COLUMN);
  const [sortOrder, setSortOrder] = useState(pageConstants.MAIN_SORT_ORDER);

  const [columnId, setColumnId] = useState<string>();
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const screenName = allScreenLabel;
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSortField(sortColumnName);
    setSortOrder(sortOrder);
  };

  const handleTopDrugsTablePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setTopDrugsTableCurrentPage(value);
  };
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  //snacker bar variables and functions
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );

  const columns: Columns[] = [
    {
      name: 'Member ID',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
      cellPadding: '8px 18px 8px 48px',
    },
    {
      name: 'Enrollment Status',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Chronic Conditions',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Diagnosis',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Speciality Costliest Drugs',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Total Cost (Medical + Rx)',
      align: 'right',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Previous Year Cost (Medical + Rx)',
      align: 'right',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
      cellPadding: '8px 28px 8px 20px',
    },
  ];

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.PAGE_HEADINGS.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  //Use History:
  const navigate = useNavigate();
  const {
    totalResults,
    memberIds: cohortMembers,
    isInitializing,
  } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMemberCountForOtherDrugs(
        employerGroupStore.employerGroupResponseData.eg_nid,
        incurredStartDate,
        incurredEndDate,
        paidStartDate,
        paidEndDate,
        aggregationParameter,
        'rx',
        'Speciality Drug',
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
    isInternal: true,
  });

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setPageNumber(page);
  };

  const handleMemberClick = (value: string) => {
    setClickedMember(value);
  };

  const handleOnClick = (value: string, key: string) => {
    navigate(DEEP_DIVE, {
      state: {
        key: key,
        value: value,
      },
    });
  };

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  //API CALLS AND DATA FORMATTING:

  //charts data
  const [drugSurgeChartData] = useState<IRxDrugSurgeChartData>({
    labels: [],
    brandedCurrentYearValues: [],
    brandedPreviousYearValues: [],
    genericCurrentYearValues: [],
    genericPreviousYearValues: [],
  });

  // const [
  //   drugCategoriesOfCancerChartData,
  //   setDrugCategoriesOfCancerChartData,
  // ] = useState<IDrugCategories[]>([]);
  // const [
  //   drugCategoriesOfNonCancerChartData,
  //   setDrugCategoriesOfNonCancerChartData,
  // ] = useState<IDrugCategories[]>([]);

  const {
    overAllEnrolled,
    overallTotalCost,
    getTotalEligible,
  } = useTotalEligible(
    aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    employerGroupStore,
    abortController.signal,
  );

  const getSummary = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.pharmacySpend +
      properties.pharmacySummary;

    const requestBody = {
      ...payload,
      claim_type: 'rx',
      speciality_drug_type: 'Speciality Drug',
      member_id_list: cohortDetailsStore.memberUniqueIdList || [],
    };

    const defaultResponse = {
      memberIdList: [],
      numberOfEmployees: 0,
      numberOfDependents: 0,
      totalCost: 0,
    };

    return await axios
      .post(url, requestBody, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          return res?.data?.data;
        }
        return defaultResponse;
      })
      .catch(() => {
        return defaultResponse;
      });
  };

  const getRiskMembersList = async () => {
    setTableLoading(true);

    const startYear = moment(
      aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    ).year();
    const response = await axios.post(
      properties.aiqBaseUrl + properties.membersList,
      {
        eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
        startYear: startYear,
        member_unique_id_list: memberIds,
        pageNumber: pageNumber - 1,
        pageSize: pageSize,
        specialityDrugType: 'Speciality Drug',
        startDate:
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
        endDate:
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        max_claim_date:
          employerGroupStore.employerGroupResponseData.max_claim_date,
        diagnosis_count: 3,
        diagnosis_sort_field: 'totalPaid',
        sortField: 'totalCost',
        sortOrder: -1,
        columnList: specialityDrugColumns,
      },
    );

    if (response?.status === 200) {
      const updatedData = await Promise.all(
        response?.data?.data?.memberList?.map(async (item: any) => {
          const memberClaimsData = await getMemberClaims(item['Member ID']);
          return {
            ...item,
            claimData: memberClaimsData?.data,
          };
        }),
      );
      setRiskMemberListData(
        formatMembersListData(updatedData, specialityDrugColumns),
      );
      setTableLoading(false);
    }
  };

  const getDrugDetails = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topDrugs;
    const body = {
      ...payload,
      medicationTypeList: ['Speciality Drug'],
      pageNumber: topDrugsTableCurrentPage - 1,
      sortField: sortField,
      sortOrder: sortOrder,
    };
    setIsTopDrugsTableLoading(true);
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          setDrugsData(
            formatTopDrugsData(
              res?.data?.data?.topDrugs,
              false,
              false,
              handleOnClick,
            ),
          );
          setTopDrugsTableTotalPages(
            Math.ceil(res?.data?.data?.totalCount / 10),
          );
          setIsTopDrugsTableLoading(false);
        }
      })
      .catch((error) => {
        setIsTopDrugsTableLoading(false);
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };
  const getMemberClaims = async (memberId: string) => {
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.membersBaseUrl +
          properties.memberDetails,
        {
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          paidStartDate,
          paidEndDate,
          incurredStartDate,
          incurredEndDate,
          aggregationParameter,
          member_unique_id: [memberId],
          claim_id_list: [],
        },
      )
      .then((response) => response.data);
  };

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      // Clean Top Drugs data (remove UI fields)
      const cleanTopDrugsData = drugsData?.map((item: any) => ({
        drugName: item?.drugName,
        claims: item?.claims,
        totalCost: item?.totalCost,
        planPaid: item?.planPaid,
        members: item?.members,
      }));

      const cleanDrugSurgeData = {
        labels: drugSurgeChartData?.labels,
        brandedCurrentYearValues: drugSurgeChartData?.brandedCurrentYearValues,
        brandedPreviousYearValues:
          drugSurgeChartData?.brandedPreviousYearValues,
        genericCurrentYearValues: drugSurgeChartData?.genericCurrentYearValues,
        genericPreviousYearValues:
          drugSurgeChartData?.genericPreviousYearValues,
      };

      const summaryData = {
        members: memberValues?.members,
        employees: memberValues?.employees,
        dependents: memberValues?.dependents,
        totalCost: totalCost?.totalCost,
        totalMedical: totalCost?.totalMedical,
        totalRx: totalCost?.totalRx,
      };

      const apiResponses = {
        title_1: summaryData,
        title_2: cleanDrugSurgeData,
        title_3: cleanTopDrugsData?.slice(0, 15), // send only top 15 drugs
      };

      let resultArray = []; // ✅ default fallback

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.SPECIALITY_DRUGS,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
         
        console.error('AI Summary API failed:', apiError);
        // ✅ Optional: show user-friendly message
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error: any) {
      handleOpenSnackBar(error, 'error', 6000);
    } finally {
      setAiLoading(false);
    }
  };
  const apiCalls = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([getSummary(), getTotalEligible()]).then(
        (responses) => {
          setCostValues({
            total: '$' + commasForNumbers(responses[0].totalCost, 2),
            medical: '',
            rx: '',
          });
          setTotalCost({
            totalCost: '$' + numFormatterWithSuffix(responses[0].totalCost, 2),
            totalMedical: '',
            totalRx: '',
          });
          setMemberValues({
            members: commasForNumbers(
              String(
                responses[0].numberOfEmployees +
                  responses[0].numberOfDependents,
              ),
            ),
            dependents: commasForNumbers(
              String(responses[0].numberOfDependents),
            ),
            employees: commasForNumbers(String(responses[0].numberOfEmployees)),
          });
          setMemberIds(responses[0].memberIdList);
          setLoading(false);
        },
      ));

    setLoading(false);
  };

  //useEffects:

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    if (memberIds.length > 0) {
      setTotalPages(Math.ceil(memberIds?.length / pageSize));
      getRiskMembersList();
    }
  }, [pageNumber, memberIds]);

  useEffect(() => {
    if (clickedMember) {
      memberSummaryStore.setPathDetails([
        [
          'text',
          messages.BREADCRUMB,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
        ],
      ]);
      navigate(PATIENT_DETAILS);
    }
  }, [clickedMember]);

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    isPlanDatesFetched && getDrugDetails();
  }, [
    isInitializing,
    topDrugsTableCurrentPage,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    sortField,
    sortOrder,
    cohortDetailsStore.conditionsDetails,
  ]);
  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  // Page Components:
  const MedPharmaComponents = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '1182px',
      },
      flex: {
        display: 'flex',
      },
      loader: {
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      tableGrid: {
        maxHeight: '282px',
        overflowY: 'auto',
        ...scrollBarStyles,
      },
    });

    const { classes } = useStyles();
    return (
      <>
        <Grid container className={classes.root}>
          <CohortFilterBar />
          <Grid style={{ display: 'flex', marginBottom: '29px' }}>
            <Grid style={{ marginRight: '24px' }}>
              <OverviewCardTooltipContent
                type="member"
                cohortMemberValues={memberValues}
                totalMemberValues={{
                  dependents: overAllEnrolled.dependents,
                  employees: overAllEnrolled.employees,
                  members: overAllEnrolled.totalCount,
                }}
                overviewCard={
                  <OverviewCard
                    title={messages.OVERVIEW_CARDS.MEMBERS}
                    value={getCohortValue(
                      memberValues.members,
                      overAllEnrolled.totalCount,
                    )}
                    rootStyles={{
                      width: '176px',
                      height: '100px',
                    }}
                  />
                }
              />
            </Grid>

            <Grid style={{ marginRight: '24px' }}>
              <OverviewCardTooltipContent
                type="cost"
                hideDetailedInfo={true}
                cohortCostValues={costValues}
                totalCostValues={{
                  medical: overallTotalCost.totalMedical,
                  rx: overallTotalCost.totalRx,
                  total: overallTotalCost.totalCost,
                }}
                overviewCard={
                  <OverviewCard
                    title={messages.OVERVIEW_CARDS.COST}
                    value={getCohortValue(
                      (totalCost?.totalCost).toString(),
                      overallTotalCost.totalCost,
                    )}
                    rootStyles={{
                      width: '216px',
                    }}
                  />
                }
              />
            </Grid>

            {/* temporary disabling pmpm and pepm cards */}
            <Grid style={{ marginRight: '24px', display: 'none' }}>
              <OverviewCard
                title={messages.OVERVIEW_CARDS.PMPM}
                value={pmpm?.pmpm}
                rootStyles={{
                  width: '176px',
                  height: '100px',
                }}
              />
            </Grid>

            <Grid style={{ marginRight: '24px', display: 'none' }}>
              <OverviewCard
                title={messages.OVERVIEW_CARDS.PEPM}
                value={pepm?.pepm}
                rootStyles={{
                  width: '176px',
                  height: '100px',
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Box style={{ marginBottom: '28px' }}>
          <Grid style={{ marginTop: '28px' }}>
            <CardComponent
              title={messages.DRUGS_TABLE}
              subTitle={messages.DRUGS_TABLE_SUBTITLE}
              height="auto"
              width="1177px"
              body={
                isTopDrugsTableLoading ? (
                  <Box
                    style={{
                      display: 'flex',
                      height: '450px',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <CircularLoader />
                  </Box>
                ) : (
                  <>
                    <Grid style={{ margin: '7px 0px 0px 6px' }}>
                      <BasicTable
                        columns={topDrugsTableColumn}
                        cellHeight="56px"
                        cellPadding="12px 9px 12px 14px"
                        rowsData={drugsData}
                        displayType="row"
                        tableHeight="auto"
                        columnId={columnId}
                        handleHeaderMouseEnter={(column: any) =>
                          handleHeaderMouseEnter(column, setColumnId)
                        }
                        handleHeaderMouseLeave={() =>
                          handleHeaderMouseLeave(setColumnId)
                        }
                        showOnHoverHeader={true}
                        handleMenuItem={handleSort}
                        width="1100px"
                        noDataText={messages.NO_DATA_DRUGS}
                      />
                    </Grid>
                    <Grid
                      container
                      style={{
                        marginTop: '16px',
                      }}
                      sx={{
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Pagination
                        page={topDrugsTableCurrentPage}
                        count={topDrugsTableTotalPages}
                        onChange={handleTopDrugsTablePageChange}
                        size="small"
                        color="primary"
                      />
                    </Grid>
                  </>
                )
              }
            />
          </Grid>
        </Box>
        {/* <Box style={{ display: 'flex', marginBottom: '28px' }}>
          <Box style={{ marginRight: '24px' }}>
            <DrugCategoriesChart
              title={pageConstants.DRUG_CATEGORIES_CANCER_TITLE}
              subTitle={pageConstants.DRUG_CATEGORIES_CANCER_SUBTITLE}
              cardHeight={'341px'}
              data={drugCategoriesOfCancerChartData}
            />
          </Box>
          <Box>
            <DrugCategoriesChart
              title={pageConstants.DRUG_CATEGORIES_NON_CANCER_TITLE}
              subTitle={pageConstants.DRUG_CATEGORIES_NON_CANCER_SUBTITLE}
              cardHeight={'341px'}
              data={drugCategoriesOfNonCancerChartData}
            />
          </Box>
        </Box> */}
        <Grid id="member-details">
          <CardComponent
            title={
              <Grid className={classes.flex}>
                <Typography
                  fontSize="16px"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  fontType="semiBold"
                  margin="2px 8px 0px 0px"
                >
                  Members Details
                </Typography>
              </Grid>
            }
            subTitle={'View the member details'}
            body={
              tableLoading ? (
                <Grid className={classes.loader}>
                  <CircularLoader />
                </Grid>
              ) : (
                <BasicTable
                  displayType="row"
                  columns={columns}
                  rowsData={riskMemberListData}
                  isCollapsiblePatientTable={true}
                  isFullTable
                  getMemberId={handleMemberClick}
                  headerCellHeight="46px"
                  showPagination={true}
                  pageCount={totalPages}
                  handlePagination={handlePageChange}
                  pageNumber={pageNumber}
                />
              )
            }
            padding="32px 36px 24px 24px"
            mainGridStyles={{
              marginTop: '41px',
            }}
            width="1182px"
          />
        </Grid>
      </>
    );
  };

  return (
    <>
      {isPlanDatesLoading || loading || isInitializing ? (
        <Loader />
      ) : (
        <div>
          <Grid container className={classes.root}>
            <Grid style={{ marginBottom: '20px' }}>
              <Breadcrumbs
                itemList={[
                  [
                    'text',
                    utilizationRx.titleAndSubtitle.title,
                    {
                      color: patientAccessTheme.palette.primary[500],
                      fontWeight: 500,
                    },
                    () => {
                      navigate(RX_UTILIZATION);
                    },
                  ],
                  [
                    'text',
                    messages.PAGE_HEADINGS.TITLE,
                    {
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    },
                  ],
                ]}
              />
            </Grid>

            <Grid
              style={{
                marginBottom: '18px',
                width: '1182px',
                position: 'relative',
              }}
            >
              <PageTitleAndSubTitle
                title={messages.PAGE_HEADINGS.TITLE}
                subTitle={messages.PAGE_HEADINGS.SUB_TITLE}
                showDownloadButton={true}
                downloadButtonAction={() => {
                  downloadPdf(
                    'individualPharmacyUtilizationReport',
                    {
                      startDate:
                        aggregationParameter === 'paid'
                          ? paidStartDate
                          : incurredStartDate,
                      endDate:
                        aggregationParameter === 'paid'
                          ? paidEndDate
                          : incurredEndDate,
                      employer:
                        employerGroupStore?.employerGroupResponseData
                          ?.employer_group_name,
                      member_unique_id_list: [],
                      claim_id_list: [],
                      category: 'specialtyDrugs',
                      maxClaimDate:
                        employerGroupStore?.employerGroupResponseData
                          ?.max_claim_date,
                      ...payload,
                    },
                    handleOpenSnackBar,
                    'open',
                  );
                  handleOpenSnackBar(
                    snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                    'info',
                    6000,
                  );
                }}
                showAskAi={true}
                askAiAction={handleAskAi}
                showQueryDataButton={checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )}
                queryButtonText={
                  cohortDetailsStore.cohortDetailsList?.length > 0 &&
                  cohortDetailsStore.cohortDetailsList[0].category !== ''
                    ? 'Edit Cohort'
                    : 'Add Cohort'
                }
                queryDataAction={() => {
                  if (
                    checkUserAccess(
                      UserAccessConstants.COHORT_DETAILS,
                      loginPageStore.userResponse.role.name,
                      loginPageStore.userFeatures,
                    )
                  ) {
                    openModal();
                  }
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '-3px',
                  left: '142px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  {COMMON_TEXTS.FOR}
                </Typography>
                <DateFilter />
              </div>
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>
            <Grid>
              {selectedTabIndex === 0 && (
                <>
                  <MedPharmaComponents />
                </>
              )}
              {selectedTabIndex === 1 && (
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                  isInternalPage={false}
                />
              )}
            </Grid>
            <div id="scroll-top-element" />
          </Grid>
          {pageScrollDown('scroll-top-element')}
        </div>
      )}
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        }
        endDate={
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        }
      />
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={cohortMembers}
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
    </>
  );
});

export default SpecialityDrugsPage;
